import { useGetForm } from 'api/hooks/private/forms/GetForm';

import PdfViewer from './components/PdfViewer';

interface PreviewProps {
  formId: string;
}

export function Preview({ formId }: PreviewProps) {
  // fetch the form
  const form = useGetForm({
    variables: {
      id: formId ?? '',
    },
    enabled: !!formId,
  });

  return <>{form.data?.link && <PdfViewer fileUrl={form.data?.link} />}</>;
}

export default Preview;
